import React from 'react';
import { Divider } from 'antd';
import { useTranslations } from 'next-intl';

interface IProps {
  componentFor?: string;
}

const RequiredSubjects: React.FC<IProps> = ({ componentFor }) => {
  const t = useTranslations();

  return (
    <div className="m-3 rounded-xl bg-white p-4 pt-5 sm:mx-0 my-3">
      <div className="inline rounded-lg bg-red-50 p-2 text-sm font-medium text-red-500">
        3 {t('ta_majburiy_fanlar')}
      </div>
      <div className="mt-5 flex items-center justify-between">
        <p className="font-medium">{componentFor === 'dtm' ? 'DTM' : t('home.banner.Virtualtest')}</p>
        <p className="text-sm text-gray-700">{t('savollar_soni')}</p>
      </div>
      <Divider className="!my-2" />
      <div className="space-y-1 text-sm">
        <div className="flex items-center justify-between">
          <p className="text-gray-800">{t('Ona_tili')}</p>
          <p className="text-gray-700">10 {t('ta')}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-gray-800">{t('Matematika')}</p>
          <p className="text-gray-700">10 {t('ta')}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-gray-800">{t('Ozbekiston_tarixi')}</p>
          <p className="text-gray-700">10 {t('ta')}</p>
        </div>
      </div>
    </div>
  );
};

export default RequiredSubjects;
